import { AgmCoreModule } from '@agm/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';

import { BannerModule } from '@shared/banner/banner.module';
import { CommonLibraryModule } from '@common-library/common-library.module';
import { FeatureToggleModule } from '@shared/services/feature-toggle/feature-toggle.module';
import { FooterModule } from '@shared/footer/footer.module';
import { HeaderModule } from '@shared/header/header.module';
import { LDComponentsModule } from '@ld-angular-components';
import { lightningReducer } from '@app/store';
import { ModalCompositesModule } from '@shared/modals/composites/modal-composites.module';
import { PageNotFoundModule } from '@app/pages/page-not-found/page-not-found.module';
import { routes } from '@app/routes';
import { SessionServiceModule } from '@shared/services/session';
import { GOOGLE_MAPS_API_KEY } from '@app/clpbp-app.settings';
import { SharedModule } from '@shared/shared.module';
import { TooltipModule } from '@shared/tooltip';

export const imports = [
  AgmCoreModule.forRoot({
    apiKey: GOOGLE_MAPS_API_KEY,
    libraries: ['places']
  }),
  BannerModule,
  BrowserAnimationsModule,
  BrowserModule,
  CommonLibraryModule,
  FeatureToggleModule,
  FooterModule,
  FormsModule,
  HeaderModule,
  HttpModule,
  LDComponentsModule,
  ModalCompositesModule,
  PageNotFoundModule,
  ReactiveFormsModule,
  RouterModule.forRoot(routes, {
    enableTracing: false
  }),
  SessionServiceModule,
  SharedModule,
  StoreModule.forRoot(lightningReducer),
  TooltipModule,
  ToastrModule.forRoot({
    positionClass: 'toast-top-center',
    preventDuplicates: true
  })
];
